import { cn } from "@newxsystems/shared";
import { Icon } from "@templates/design-system";
import { WohaCardLink } from "../../../../modules/content/components/WohaCardLink/WohaCardLink";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IIconContentGridBlockProps } from "./IconContentGridBlock.props";
const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;
const accents = [
  "bg-soft-orange text-tangerine",
  "bg-soft-mint text-vivid-green",
  "bg-soft-violet text-lavender",
  "bg-soft-blue text-electric-blue",
] as const;
export const IconContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IIconContentGridBlockProps) => {
  if (!items?.length) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid grid-cols-1 gap-4 sm:grid-cols-2", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <WohaCardLink
              className={cn("p-5", spans[item.columnSpan || 1])}
              key={index}
              link={item.cardLink}
            >
              <div
                className={cn(
                  "mb-8 inline-flex size-10 items-center justify-center rounded-full",
                  accents[index % accents.length],
                )}
              >
                <Icon className="size-5" name={item.icon} />
              </div>
              <h3 className="text-xl font-medium text-charcoal">{item.heading}</h3>
              {item.description ? (
                <WohaRichText
                  className="mt-2 text-base leading-6 text-steel"
                  content={item.description}
                />
              ) : null}
            </WohaCardLink>
          ))}
        </div>
      </div>
    </WohaSection>
  );
};
IconContentGridBlock.displayName = "Block::IconContentGridBlock";
